import { Slido } from '@livekatsomo/models';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'next-i18next';
import { SlidoForm } from './SlidoForm';

/**
 * Props for the SlidoDialog component.
 * @property {boolean} open - Whether the dialog is open or not.
 * @property {Slido | null | undefined} slido - The Slido object to be edited.
 * @property {() => void} onClose - Function to be called when the dialog is closed.
 * @property {(slido: Slido) => Promise<void>} onSubmit - Function to be called when the form is submitted.
 */
export interface SlidoDialogProps {
  open: boolean;
  slido?: Slido | null;
  onClose: () => void;
  onSubmit: (slido: Slido) => Promise<void>;
}

/**
 * A dialog component for editing a Slido object.
 * @param {SlidoDialogProps} props - The props for the SlidoDialog component.
 * @returns  - The SlidoDialog component.
 */
export function SlidoDialog({
  open: isOpen,
  slido,
  onClose,
  onSubmit,
}: SlidoDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog scroll="body" open={isOpen} onClose={onClose}>
      <Box sx={{ position: 'relative' }}>
        <DialogTitle>{t('Edit Slido')}</DialogTitle>
        <SlidoForm onClose={onClose} onSubmit={onSubmit} slido={slido} />
      </Box>
    </Dialog>
  );
}

export default SlidoDialog;
